<template>
    <div id="app">
        <div class="mala-content clearfix" id="malaContent" :class="oemTemplate[company.config.systemTheme].className" v-if="company != ''">
            <!-- 头部导航 -->
            <Topmenu ref="topMenu" v-if="company.config.hideAllMenus == 0 " :downloadImg='company.config.appDownloadQrcode'></Topmenu>
            <!-- 左侧导航 -->
            <Myleft v-if="$route.meta.leftShow && company.config.hideAllMenus == 0 " ref="left" :name="isPlan.name"></Myleft>
            <div class="right-div" ref="child" :class="!$route.meta.leftShow ? 'ml0' : ''" :style="company.config.hideAllMenus == 1 ? 'margin-left:0;top:0px;' : ''">
                <!-- 跟方案有关的显示 -->
                <crumbs v-if="isPlan !='' &&  $route.meta.planCut"></crumbs>  
                <router-view v-if="isPlan !='' &&  $route.meta.planCut"></router-view>
                <!-- 跟方案无关显示 -->
                <router-view v-if="!$route.meta.planCut"></router-view>  
            </div>
            <!-- 登录 -->
            <login ref="logins"></login>
            <!-- QQ 微信 电话悬浮框 -->
            <kefu></kefu>
        </div>
        <!-- 提示弹框 -->
        <Dialog ref="tipsModal" type="alert">
            <div slot="mdBox">
                <p class="ac" v-html="tipsHtml"></p>
            </div>
        </Dialog>
        <!-- loading -->
        <div class="loadBox ac" id="loadBox" v-show="showLoad">
            <div class="loadCont">
                <img src="/static/images/loading1.gif"/>
                <p>{{loadHtml}}</p>
            </div>
        </div>
		<!-- 预警提示弹框 -->
		<div class="caution-mask" ref="cautionMask" v-if="cautionList != '' && cautionStorage != 1">
		    <a class="close" href="javascript:void(0);" @click="closeCaution();"><img src="/static/images/close.png" class="db"/></a>
		    <div class="caution-header">
		        <span class="fl">预警通知</span>
		        <span class="fr">今日新增预警（<i class="color-red">{{cautionList.numFound}}</i>条）</span>
		    </div>
		    <div class="caution-body">
		        <ul class="caution-new">
		            <li v-for="(item,index) in cautionList.newsList" :key="index">
		                <router-link class="color-3d3d4c" target="_blank" :to="{path:'/detail',query: {data:item.newsId+','+item.newsSimHash+','+item.startDate+','+item.endDate}}">
		                    <h3 class="article-title ovhidden"><span class="tag" :class="attributeType[item.newsEmotion]">{{item.newsEmotion}}</span><span>{{item.newsTitle}}</span></h3>
		                </router-link>
		                <p class="ziduan color-8a8a99">
		                    <span>时间：{{item.solrCreateTime}}</span>
		                    <span>发布人：{{item.platformName}}</span>
		                </p>
		            </li>
		        </ul>
		    </div>
		</div>
    </div>
</template>

<script>
import Dialog from '@/components/dialog'
import login from '@/page/index/login'
import Myleft from '@/components/left'
import Topmenu from '@/components/topMenu'
import kefu from '@/components/kefu'
import crumbs from '@/components/crumbs.vue';
export default {
  components: {Myleft,Topmenu,Dialog,login,kefu,crumbs},
  name: 'App',
  data(){
        return{
            company:'',//公司基本配置
            oemTemplate:{
                'red':{
                    'className':'red-template',
                    'mapColor':["#ff3434", "rgba(255,52,52,.2)"],
                },
                'green':{
                    'className':'green-template',
                    'mapColor':["#00cc74", "rgba(0,204,116,.2)"],
                },
                'blue':{
                    'className':'',
                    'mapColor':["#16aaff", "#0c1974"],
                }
            },//模板的颜色class属性
			attributeType:{
			    '正面':'tag-blue',
			    '中性':'tag-orange',
			    '负面':'tag-red',
			},//属性对应的class样式
            icons:{
                'wx':'wx-icon',
                'web':'web-icon1',
                'weibo':'wb-icon1',
                'app':'app-icon1',
                'bbs':'bbs-icon1',
                'journal':'bk-icon1',
                'media_toutiao':'tt-icon1',
                'media_qq':'qq-icon1',
                'media_baijia':'bj-icon1',
                'media_sohu':'sh-icon1',
                'media_wangyi':'wy-icon1',
                'media_people':'people-icon1'
            },
            iframeMenus:[],
            expireTime:'',//会员到期时间
            realmName:'',//域名
            tipsHtml:'',//提示语句
            headImg:'',//用户头像
            isAdmin:false,
            // newest:false,//最新公告标识
            nickname:'',//用户昵称
            // memberTypeName:'',//会员名称
            // memberType:'',//会员等级
            timeSection:90,//数据查询跨度时间
            // remainSmsNum:'',//短信剩余量
            isPlan:'',//判断是否有方案
            isIframe:false,//控制iframe的地址获取
            isSignin:false,
            // newNotice:'',//新消息
            // notceTips:false,//新消息开关
            // remainDownloadNum:'',//下载剩余量
            showLoad:false,
            isSupportArtificialWarningSet:-1,//是否支持人工预警设置
            isSupportFullTextSearch:-1,//是否支持全文检索
            loadHtml:'正在加载...',
            selectOption:[
                {'name':'标题','type':'news_title'},
                {'name':'摘要','type':'news_digest'},
                {'name':'作者','type':'news_author'},
				{'name':'分析词','type':'keyword_count'},
                {'name':'发布人','type':'media_name'},
                {'name':'原作者','type':'news_origin_author_name'},
                {'name':'主题词','type':'news_keywords'},
                {'name':'阅读数','type':'news_read_count'},
                {'name':'点赞数','type':'news_like_count'},
                {'name':'评论数','type':'news_comment_count'},
                {'name':'转发数','type':'news_reposts_count'},
                {'name':'原文链接','type':'news_url'},
                {'name':'媒体类型','type':'platform_name'},
                {'name':'情感属性','type':'news_emotion'},
                // {'name':'情感分值','type':'news_emotion_score'},
                {'name':'提及地区','type':'news_content_province'},
                {'name':'发布时间','type':'news_posttime'},
                {'name':'发布地区','type':'media_province'},
                {'name':'相似文章条数','type':'sim_count'}
            ],//全局下载配置
            cautionList:'',//底部弹框预警列表
			cautionStorage:''//判断是否手动关闭了预警弹框
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            //获取配置
            that.getCompany();
        })
    },
    created() {
        
        
    },
    methods:{
        // 获取皮肤等配置
        getCompany (isLogin) {
            let that = this;
            that.loadModal(true,'获取数据，请稍后...');
            that.$api.get('config/company/info',null,r =>{
                that.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.company = r.data;
                    that.$store.dispatch('show/companyinfo',r.data);
                    //ico图标
                    let link = document.createElement('link');
                    link.type = 'image/x-icon';
                    link.rel = 'shortcut icon';
                    link.href = r.data.config.systemIcon;
                    document.getElementsByTagName('head')[0].appendChild(link);
                    //页面title配置
                    let title = that.$route.meta.title;//页面的title
                    let touteName = that.$route.name;//页面的title
                    let hotEvent = that.$route.meta.pageType;//判断热点事件页面
                    sessionStorage.setItem('pageTitle', r.data.config.systemTitle);//储存页面标题的公共部分
                    if(touteName === 'index'){//首页
                        that.isIframe = true;//首次判断是首页时置为true
                        document.title = r.data.config.systemTitle;
                    }else{
                        that.isIframe = false;//首次判断是其他路由时置为false
                        document.title = title + r.data.config.systemTitle;
                    }
                    // if(hotEvent === 2 && that.company.config.openHotEvent != 1){//未开启热点事件
                    //     // that.$router.push({path:'/'});
                    // }
                    // 验证登录信息
                    let host = window.location.host;
                    that.realmName = 'http://' + host + '/';
                    let cooke = document.cookie.indexOf("xiaohuozi");
                    console.log('浏览器cooke：',cooke)
                    if(cooke != -1){
                        that.getUserInformation();
                    }else{
                        if(that.$route.meta.requireAuth){
                            that.$router.push({path:'/'});
                            that.isIframe = true;
                        }
                    }
                });         
            }) 
        },
        //获取当前方案
        getCurrplan (isLogin) {
            let that = this;
            that.loadModal(true,'数据加载中...');
            that.$api.get('monitor/scheme/show',null,r =>{
                that.showLoad = false;
                that.$utils.returnCode(r,function(){
                    let value = r.data;
                    that.curCompetPlan = value.competeInfo;
                    sessionStorage.setItem('havePlanid',value.id==''?null:value.id); 
                    if(value.id == ''&&that.isAdmin){//没有方案
                        window.sessionStorage.removeItem('planStorage')
                        if(that.$route.meta.planCut){
                            that.$router.push({ path:'/analysis/buildSolution'});
                        }
                    }else if(!that.isAdmin&&value.id == ''){
                        that.$router.push({ path:'/vipRight'});
                    }else{
                        that.isPlan = value;
                        sessionStorage.setItem('planStorage', JSON.stringify(value));
						that.cautionStorage =  sessionStorage.getItem('caution');
						that.getCaution();
                        if(isLogin != undefined){//从登陆来的
                            // that.$router.push({ path:'/'})
                        }
                        // let redirect = that.$route.query.redirect;
                        // that.$router.push({path:redirect});
                    }
                    
                });           
            })   
        },
        // 个人中心获取数据
        getUserInformation () {
            let that = this;
            // that.loadModal(true,'数据加载中...');
            that.$api.get('user/index/index',null,r =>{
                that.$utils.returnCode(r,function(){
                    let value = r.data;
                    that.isAdmin = value.isAdmin;
                    that.expireTime = value.expireTime;
                    that.headImg = value.headImg;
                    that.nickname = value.nickname;
                    that.getCurrplan(true);
                    that.$store.dispatch('user/getUserinfo',value);
                    
                    // that.memberTypeName = value.memberTypeName;
                    // that.memberType = value.memberType;
                    // that.remainSmsNum = value.remainSmsNum;
                    that.remainDownloadNum = value.remainDownloadNum;
                    that.iframeMenus = value.menus;
                    that.company.config.openMultiSchemeInfo = value.authority.openMultiSchemeInfo;
                    that.isIframe = true;
                    
                    that.getJurisdiction();
                    that.isSignin = true;
                    // that.getNewNotice();
                });         
            })   
        },
        // 获取权限
        getJurisdiction () {
            let that = this;
            that.$api.get('user/index/config-index',null,r =>{
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    that.isSupportArtificialWarningSet = data.isSupportArtificialWarningSet;
                    that.isSupportFullTextSearch = data.isSupportFullTextSearch;
                    that.timeSection = data.searchDays;
                });         
            })  
        },
        // 获取公告状态
        getNewNotice () {
            let that = this;
            that.$api.get('user/index/get-unread-notice',null,r =>{
                that.$utils.returnCode(r,function(){
                    if(r.data.num > 0){
                        that.newest = true;
                    }
                    that.newNotice = r.data.notice;
                    if(r.data.notice.length == undefined){
                        that.notceTips = true;
                    }
                });         
            })  
        },
		// 获取预警通知
		getCaution () {
		    let that = this;
		    if(that.cautionStorage === '1'){//sessionStorage存在就不显示预警
		        return;
		    }
		    that.$api.get('monitor/warning/warn-notice',{sid:that.isPlan.id},r =>{
		        that.$utils.returnCode(r,function(){
		           that.cautionList = r.data;
		        });         
		    })
		},
		// 关闭预警通知
		closeCaution () {
		    this.cautionStorage = '1';
		    sessionStorage.setItem('caution', '1');
		},
        loadModal(isShow,txt){
            let that = this;
            if(txt!=''){
                that.loadHtml = txt;
            }
            that.showLoad = isShow;
        },
        // alert提示
        alertTips (text) {
            this.tipsHtml = text;
            this.$refs.tipsModal.showMaskFun();
        }
        // // code判断
        // returnCode (data,callback) {
        //     let code = data.code;
        //     if(code === 10000){
        //         callback();
        //     }else{
        //         if(code === 10004){//会员过期
        //             if($('.alertText').length <= 0){
        //                 this.$utils.alertText('会员已过期，请购买会员');
        //             }
        //             // window.location.href=""+this.realmName+"vipRight";
		// 			 this.$router.push({ path:'/vipRight'});
        //         }else if(code === 10003){//未登录
        //             this.$refs.topMenu.logOut();
        //         }else{
        //             if(data.msg != undefined){
        //                 this.$utils.alertText(data.msg);
        //             }
        //         }
        //     }
        // }       
    }
}
</script>

<style>
  @import "./style/animate.css";
  @import "../static/font/iconfont.css";
  @import "//at.alicdn.com/t/font_2210789_uot6p5u31ac.css";
  @import "./style/base.css";
  @import "./style/style.css";
</style>



// WEBPACK FOOTER //
// src/App.vue